export const SSO_ERROR_REDIRECTING_IN_5_SECONDS =
  'We\'ve encountered an error during SSO login. You will be redirected in 5 seconds';
export const REDIRECT_MS = 5000;
